import React from 'react';
import { CheckCircle } from 'lucide-react';

interface SuccessMessageProps {
  message: string;
  className?: string;
  showIcon?: boolean;
}

/**
 * Success message component for displaying success feedback
 */
const SuccessMessage: React.FC<SuccessMessageProps> = ({ 
  message, 
  className = '',
  showIcon = true 
}) => {
  if (!message) return null;

  return (
    <div 
      className={`p-3 bg-green-50 border border-green-200 rounded-lg text-green-600 text-sm ${className}`}
      role="alert"
    >
      <div className="flex items-start gap-2">
        {showIcon && (
          <CheckCircle className="h-4 w-4 mt-0.5 flex-shrink-0" />
        )}
        <p className="flex-1">{message}</p>
      </div>
    </div>
  );
};

export default SuccessMessage;

